import React from "react";
import "./testimonial.css";
import Client from "../../assets/client.jpg";

// import Swiper core and required modules
import { Pagination} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';


const data = [
  {
    id: 1,
    avatar: Client,
    name: "harry brook",
    review:
      "Lorem ipsum dolor Lorem ipsum dolor sit ametLorem ipsum dolor sit ametsit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit amet",
  },
  {
    id: 2,
    avatar: Client,
    name: "mical jone",
    review:
      "Lorem ipsum dolor Lorem ipsum dolor sit ametLorem ipsum dolor sit ametsit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit amet",
  },
  {
    id: 3,
    avatar: Client,
    name: "jonty rode",
    review:
      "Lorem ipsum dolor Lorem ipsum dolor sit ametLorem ipsum dolor sit ametsit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit ametLorem ipsum dolor sit amet",
  },
];
const Testimonial = () => {
  return (
    <section id="testimonial">
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper className="container testimonial__container"
       // install Swiper modules
       modules={[Pagination]}
       spaceBetween={40}
       slidesPerView={1}
       
       pagination={{ clickable: true }}
      >
        {data.map(({ id, avatar, name, review }) => {
          return (
            <>
              <SwiperSlide key={id} className="testimonial">
                <div className="client__avatar">
                  <img src={avatar} alt={name} />
                </div>
                <h5 className="client__name">{name}</h5>
                <small className="client__review">{review}</small>
              </SwiperSlide>
            </>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Testimonial;
